module.exports = __webpack_public_path__ + "img/repositorio_unico_bg.ee9fb642.webp";